/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 静脈路確保部位
 */
export type TreatmentIVAccessPartEnum =
  (typeof TreatmentIVAccessPartEnum)[keyof typeof TreatmentIVAccessPartEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentIVAccessPartEnum = {
  BACK_OF_HAND: 'BACK_OF_HAND',
  FOREARM: 'FOREARM',
  MIDLINE: 'MIDLINE',
  DORSUM_FOOT: 'DORSUM_FOOT',
  OTHER: 'OTHER',
} as const;
